import React from 'react';
import { CheckIcon } from 'lucide-react';
import { deliverables } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-white py-16 md:py-24" data-id="element-178" data-mp="1026tkephop2s">
      <div className="mx-auto w-full max-w-narrow px-5 md:px-8" data-id="element-179" data-mp="l44pm3ejq1l0">
        <header className="text-center" data-id="element-180" data-mp="q2fz2d0xia2p">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-amber-700" data-id="element-181" data-mp="q3h86bydwmhs">
            Senza sorprese
          </p>
          <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.1] tracking-tight text-night md:text-5xl" data-id="element-182" data-mp="1ducyf4n6z9mx">
            Esattamente cosa ricevi oggi
          </h2>
        </header>

        <ul className="mt-12 divide-y divide-gray-200 overflow-hidden rounded-2xl bg-white shadow-soft ring-1 ring-gray-200" data-id="element-183" data-mp="140cx7dv16ojh">
          {deliverables.map(item => <li key={item} className="flex items-start gap-4 px-5 py-5 md:px-8" data-id="element-184" data-mp="1wpbgwfesxyqw">
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-grass-500 text-white" data-id="element-185" data-mp="21impom36cplg">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-186" data-mp="2vg3orozzd4n6" />
              </span>
              <span className="text-lg leading-snug text-ink" data-id="element-187" data-mp="2qiajqzaeygoh">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}